import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { AuthGuard } from 'app/core/services/auth/auth-guard.service';

import {
  UsuarioPerfil,
  usuarioPerfilAdministrador,
  usuarioPerfilAtendente,
  usuarioPerfilFinanceiro,
  usuarioPerfilGerente,
  usuarioPerfilRepresentante
} from 'app/home/usuario/usuario-perfil';

export const acessosMatrizPic: UsuarioPerfil[] = [
  usuarioPerfilAdministrador,
  usuarioPerfilRepresentante,
  usuarioPerfilGerente,
  usuarioPerfilAtendente,
  usuarioPerfilFinanceiro
];

@Injectable({
  providedIn: 'root'
})
export class MatrizPicGuard implements CanActivate {
  constructor(private authGuard: AuthGuard) {}

  canActivate() {
    return this.authGuard.canActivateAcesso(acessosMatrizPic);
  }
}
